/**
I  * Brand mark — uses shared consumer lockup from /public/branding.
 */
export function TensionLogo({
  className = '',
  height = 40,
  tone = 'auto',
  priority,
}: {
  className?: string;
  /** CSS pixel height; width scales with aspect ratio */
  height?: number;
  /** Controls wordmark contrast in mixed backgrounds */
  tone?: 'auto' | 'light' | 'dark';
  /** Hint for LCP on landing */
  priority?: boolean;
}) {
  const logoSrc =
    tone === 'light'
      ? '/assets/tension/brand/logo-main.png'
      : '/assets/tension/brand/logo-main.png';

  return (
    <img
      src={logoSrc}
      alt="TENSION"
      width={765}
      height={393}
      className={`h-auto w-auto max-w-full shrink-0 object-contain object-left ${className}`.trim()}
      style={{ maxHeight: height }}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
    />
  );
}
